import { RefObject } from 'react';
import { HELPER_ARTICLES, APP_ROUTE } from '../../constants';
import { contactUs } from '../../helpers';

export const ERROR_SUBSTRINGS = {
  DATA_NOT_AVAILABLE_FOR_DATE: 'data not available for the given date range',
  ERROR_FETCHING_INSIGHTS_DATA: 'error fetching insights data for',
  ACCESS_TOKEN_EXPRIED: 'access token is invalid or expired',
  ANALYTICS_DATA_PERMISSION_DENIED: 'permissions to access analytics data',
  NO_PAGE_CONNECTED: 'you need to connect a social media page',
  SOMETHING_WENT_WRONG: 'not to worry though',
};

const HELPER_TASKS = {
  OPEN_ARTICLE: 'OPEN_ARTICLE',
  NAVIGATE: 'NAVIGATE',
};

function helperTask(
  task: string,
  params: {
    articleId?: string;
    navigateTo?: string;
  }
): () => void {
  return (): void => {
    // Perform task
    switch (task) {
      case HELPER_TASKS.OPEN_ARTICLE:
        window.open(params.articleId, '_blank', 'noreferrer');
        break;
      case HELPER_TASKS.NAVIGATE:
        contactUs();
        break;
      default:
        break;
    }
  };
}

type getErrorActionParamTypes = {
  message?: string;
  navigate?: any;
  currentChannel?: string;
  dateRangePickerRef?: RefObject<any>;
  connectWithProvider?: (channel: string) => void;
};

export function getErrorAction({
  message,
  navigate,
  currentChannel,
  dateRangePickerRef,
  connectWithProvider,
}: getErrorActionParamTypes): {
  learnMoreClick: any;
  CTAText: string;
  CTAAction: any;
} {
  const errorMessage = String(message).trim().toLowerCase();
  let learnMoreClick;
  let CTAText = '';
  let CTAAction;
  if (errorMessage.includes(ERROR_SUBSTRINGS.DATA_NOT_AVAILABLE_FOR_DATE)) {
    learnMoreClick = helperTask(HELPER_TASKS.OPEN_ARTICLE, {
      articleId: HELPER_ARTICLES.MISSING_ANALYTICS_DATA,
    });

    CTAText = 'Try a new date range';

    CTAAction = (): void => {
      if (dateRangePickerRef && dateRangePickerRef.current) {
        dateRangePickerRef.current.focus();
        dateRangePickerRef.current.click();
      }
    };
  } else if (
    errorMessage.includes(ERROR_SUBSTRINGS.ERROR_FETCHING_INSIGHTS_DATA)
  ) {
    learnMoreClick = helperTask(HELPER_TASKS.OPEN_ARTICLE, {
      articleId: HELPER_ARTICLES.MISSING_ANALYTICS_DATA,
    });
  } else if (errorMessage.includes(ERROR_SUBSTRINGS.ACCESS_TOKEN_EXPRIED)) {
    learnMoreClick = helperTask(HELPER_TASKS.OPEN_ARTICLE, {
      articleId: HELPER_ARTICLES.REFRESH_ACCESS_TOKEN,
    });

    CTAText = `Update ${currentChannel} connection`;

    CTAAction = (): void => {
      if (connectWithProvider && currentChannel) {
        connectWithProvider(currentChannel);
      }
    };
  } else if (
    errorMessage.includes(ERROR_SUBSTRINGS.ANALYTICS_DATA_PERMISSION_DENIED)
  ) {
    learnMoreClick = helperTask(HELPER_TASKS.OPEN_ARTICLE, {
      articleId: HELPER_ARTICLES.MISSING_PERMISSIONS,
    });
  } else if (errorMessage.includes(ERROR_SUBSTRINGS.NO_PAGE_CONNECTED)) {
    CTAText = 'Connect a page';

    CTAAction = (): void => {
      navigate(`/${APP_ROUTE.SETTINGS}/${APP_ROUTE.WORKSPACE}`, {
        replace: true,
      });
    };
  } else if (errorMessage.includes(ERROR_SUBSTRINGS.SOMETHING_WENT_WRONG)) {
    CTAText = 'Chat with Us';

    CTAAction = (): void => {
      try {
        window.$crisp.push(['do', 'chat:show']);
        window.$crisp.push(['do', 'chat:open']);
      } catch (error) {
        console.error(error);
      }
    };
  }
  return { learnMoreClick, CTAText, CTAAction };
}
